import ApiService from './api.service.js'

const AuthService = {
  registerCompany(payload) {
    return ApiService.post('register_company', payload)
  },
  startEmployeeRegistrationByCompany(payload) {
    return ApiService.post('start_employee_registration_by_company', payload)
  },
  completeEmployeeRegistrationByCompany(payload) {
    return ApiService.post('complete_employee_registration_by_company', payload)
  },
  registerEmployeeByInvitation(payload) {
    return ApiService.post('start_employee_registration_by_invitation', payload)
  },
  createBranchEmployeeInvitation(payload) {
    return ApiService.post_extra_route('branches', payload.id, payload, 'create_employee_invitation')
  },
  confirmBranchEmployee(payload) {
    return ApiService.post('confirm_employee_invitation', payload)
  },
  getEmployeeData(id) {
    return ApiService.get('employees', id)
  },
  getEmployeePublicData(id) {
    return ApiService.get('public_employees', id)
  },
  updateEmployeeData(id, payload) {
    return ApiService.update('employees', id, payload)
  },
  joinEmployeeToBranch(payload) {
    return ApiService.post('employees/join_to_branch', payload)
  },
  login(payload) {
    return ApiService.post('login', payload)
  },
  getAccessToken() {
    return ApiService.get('access-token', '', '', { withCredentials: true })
  },
  changePassword(payload) {
    return ApiService.post('direct_password_change', payload)
  },
  getUserData() {
    return ApiService.get('current_user')
  },
  saveUserImage(payload) {
    const config = {
      headers: {
        'content-type': 'multipart/form-data'
      }
    }
    return ApiService.post('current_user/upload', payload, config)
  },
  getUserCard() {
    return ApiService.get('card')
  },
  getUserBankAccount() {
    return ApiService.get('bank_account')
  },
  updateUser(id, payload) {
    return ApiService.update('users', id, payload)
  },
  resetUserPassword(id, payload) {
    return ApiService.post('users', id, payload)
  },
  createUserCard(payload) {
    return ApiService.post('card', payload)
  },
  updateUserCard(payload) {
    return ApiService.put('card', payload)
  },
  deleteUserCard() {
    return ApiService.delete('card')
  },
  createUserBankAccount(payload) {
    return ApiService.post('bank_account', payload)
  },
  updateUserBankAccount(payload) {
    return ApiService.put('bank_account', payload)
  },
  deleteUserBankAccount() {
    return ApiService.delete('bank_account')
  },
  getVcardsAll(id) {
    return ApiService.download_file('employees/v-card', id)
  },
  getQrAll(id) {
    return ApiService.download_file('employees/qr-codes', id)
  },
  oneQrCode(uid) {
    return ApiService.download_file('employees/one-qr-codes', uid, '', 'png')
  },
  oneVcard(uid) {
    return ApiService.download_file('employees/one-v-card', uid, '', 'pdf')
  }
}

export default AuthService
